import GenericFilter, { Item } from "@/components/Filters/GenericFilter";
import { IconFileTypography } from "@tabler/icons-react";
import { LuFileType } from "react-icons/lu";

export default function CardTypeFilter({
  selected,
  setSelected,
}: {
  selected: Set<any>;
  setSelected: (selectedOptions: Set<string>) => void;
}) {
  const data = [
    { key: "Character", value: "Character" },
    { key: "Event", value: "Event" },
    { key: "Site", value: "Site" },
    { key: "Action Point", value: "Action Point" },
  ];
  return (
    <GenericFilter
      classNames="w-28"
      selected={selected}
      startContent={<IconFileTypography />}
      setSelected={setSelected}
      selectionMode="single"
      label="Type"
      data={data}
    />
  );
}
